import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { HubChannel } from './types';

export const receiveHubMessage = createAction(
  `${actionKey}.RECEIVE_MESSAGE`,
  (channel: HubChannel, data: any) => ({
    channel,
    data,
  })
);
